export default __webpack_public_path__ + "static/media/mq-new-8.dc78edec.jpg";